export default "__VITE_ASSET__iKOC7oA2__"